import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { EffectsContainer } from 'mixins/withEffects';
import ko from "knockout";
import QualzyUploaderBase from "../qualzyUploaderBase";
import {FileToUpload} from "../models/fileToUpload";
import {
    UploadToS3,
    UploadToS3Config,
    UploadToS3Events,
    UploadToS3Result,
    UploadToS3Strings
} from "../operations/uploadToS3";

import '../qualzyUploaderBase.html';
import '../qualzyUploaderBase.scss';

import './component.html';
import {UploadToS3SinglePart} from "../operations/uploadToS3SinglePart";
import {UploadToS3MultiPart} from "../operations/uploadToS3MultiPart";
import {ILogsContainer} from "../../../../logsContainer";
import {UserLogsService} from "../../../../services/userLogs";

/**
 * Uploader that upload file(s) to AWS S3 as a single file
 */
@injectable()
export default class QualzyS3FileUploader extends 
    QualzyUploaderBase<UploadToS3Result, UploadToS3Strings, UploadToS3Events, UploadToS3Config, UploadToS3>{

    /**
     * Initialise the S3 uploader control
     * @param config The configuration for the uploader
     * @param info Any component info
     * @param _ The effects container
     * @param userLogsService The user logs service to send logs to the server
     */
    constructor(
        @inject(wccModules.componentConfig) config: UploadToS3Config,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) _: EffectsContainer,
        @inject(wccModules.userLogsService) userLogsService: UserLogsService
    ) {
        super(config, userLogsService);
        
        ko.applyBindingsToNode(info.element, {
            'css': {
                'qualzy-file-uploader': true
            }
        }, this);
    }

    /**
     * Creates the s3 upload operation from a file instance
     * It creates a single part file upload if the size of the file is smaller; Otherwise it creates a multipart file upload
     * @param file The file to upload
     * @param logs The logs container
     * @protected
     */
    protected createUpload(file: File, logs: ILogsContainer): UploadToS3 {
        if (file.size > WCC.Settings.MultiPartChunkSizeBytesForClientUploader) {
            logs.addEntry("Using multi-part S3 file uploading")
            return new UploadToS3MultiPart(new FileToUpload(file.name, file.size, file.type, file), this._config, logs, this._userLogsService);
        }
        logs.addEntry("Using single-part S3 file uploading");
        return new UploadToS3SinglePart(new FileToUpload(file.name, file.size, file.type, file), this._config, logs, this._userLogsService);
    }
}